import axios from 'axios';
import * as AxiosLogger from 'axios-logger';
import { sessionLocalRepo } from '../../di/repo_module';
import { Setup } from '../../domain/setup/Setup';
import { RemoteConstants } from './RemoteConstants';

export function axiosApp(requiresToken = true) {



    const instance = axios.create();
    instance.defaults.baseURL = RemoteConstants.BASE_URL;
    instance.defaults.headers = {
        "Content-Type": "application/json",
        // "tipo": "WEB"
    }

    if (Setup.getInstance().showLogs) {
        instance.interceptors.request.use((request) => {
            return AxiosLogger.requestLogger(request, {
                prefixText: 'Axios',
                dateFormat: 'HH:MM:ss',
                headers: true,
            });
        });
        instance.interceptors.response.use((response) => {
            return AxiosLogger.responseLogger(response, {
                prefixText: 'Axios',
                dateFormat: 'HH:MM:ss',
                status: false,
                headers: true,
            })
        });
    }

    if (requiresToken) {
        const session = sessionLocalRepo().getSession();
        if (session?.token != null && requiresToken) {
            instance.interceptors.request.use((request) => {
                request.url = `${request.url}&token=${session.token}`;
                return request;
            })
        }
        /*const ip = sessionLocalRepo().getIp();
        if (ip) {
            instance.interceptors.request.use((request) => {
                request.url = `${request.url}&ip_origen=${ip}`;
                return request;
            });
        }/**/

        const lat = sessionLocalRepo().lat;
        const lng = sessionLocalRepo().lng;
        if (lat && lng) {
            instance.interceptors.request.use((request) => {
                request.url = `${request.url}&geoloc=${lat},${lng}`;
                return request;
            });
        }
        
        instance.interceptors.request.use((request) => {
            request.url = `${request.url}&tipo=WEB`;
            return request;
        });

    }

    instance.defaults.validateStatus = function (status) {
        return status >= 200 && status < 400
    }

    return instance;
}
